"use strict";

exports.__esModule = true;
exports.textInputTheme = void 0;

var _themes = require("../themes");

var _FauxControl = require("../FauxControl");

// $FlowFixMe - strict theme keys incompatible with mapComponentThemes
var textInputTheme = function textInputTheme(baseTheme) {
  return (0, _themes.mapComponentThemes)({
    name: 'FauxControl',
    theme: (0, _FauxControl.fauxControlTheme)(baseTheme)
  }, {
    name: 'TextInput',
    theme: {
      TextInput_height_small: baseTheme.size_small,
      TextInput_height_medium: baseTheme.size_medium,
      TextInput_height_large: baseTheme.size_large,
      TextInput_height_jumbo: baseTheme.size_jumbo,
      TextInputIcon_color: baseTheme.color_gray_40
    }
  }, baseTheme);
};

exports.textInputTheme = textInputTheme;